var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M330.207 85.331H512v341.337H330.207zM0 85.331h181.793v341.337H0z",
  fill: "#a2001d"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M113.163 267.125h14.84v59.359h-14.84zm-59.37 0h14.84v59.359h-14.84z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90.902,
  cy: 289.386,
  r: 14.84
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90.902,
  cy: 237.44,
  r: 7.421
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.054 311.647h29.682v14.84H76.054zm0-59.359h29.682v14.84H76.054zm14.843-66.786l5.255 16.173h17.006l-13.757 9.996 5.252 16.173-13.756-9.996-13.756 9.996 5.251-16.173-13.756-9.996h17.005z"
}))));

export default SvgMn;